/* My Acre — Ask Hayden help bubble behaviour. Markup in snippets/ma-help-bubble.liquid,
   styling in assets/ma-help-bubble.css. Split out 21 Aug 2026 so it can be deferred and
   cached, matching the ma-header.js pattern. Contains no Liquid, so it is a plain asset.

   TWO CLOCKS ON PURPOSE: the greeting reads the VISITOR's device clock (so Perth reads
   right), presence reads Australia/Sydney (that is when Hayden is awake to reply).

   DELIVERY (11 Sep 2026): enquiries go to the ma-chat-relay Cloudflare Worker at
   chat.myacre.com.au, which holds the Slack webhook as a secret and builds the Slack
   message. The webhook used to sit in this public file, where anyone could read it and
   post into the channel. Source and runbook: /My Drive/2026-09-11-chat-relay/.

   NEVER LOSE ONE (12 Sep 2026). An enquiry is written to localStorage BEFORE it is sent and
   only cleared once the relay confirms it is stored. So a closed tab, a dropped connection,
   a blocking extension or a flat spot in the mobile signal no longer ends the lead: it is
   retried here, and replayed on the visitor's next page view. The relay de-duplicates on
   the cid, so a replay can never produce two Slack messages for one enquiry. */
(function () {
    var RELAY_ORIGIN = 'https://chat.myacre.com.au'; /* Worker ma-chat-relay; the Slack webhook lives there as a secret */
    var RELAY_URL = RELAY_ORIGIN + '/enquiry';
    var OPEN_HOUR = 7, CLOSE_HOUR = 21; /* Australia/Sydney. Presence only, not the greeting. */
    var WIDGET_V = '2026-09-12';   /* rides along on every enquiry, so a stale client is visible in D1 */
    var PENDING_KEY = 'ma_hb_pending';
    var PENDING_LIFE = 604800000;  /* 7 days; after that a replay is stale enough to drop */
    var SEND_DEADLINE = 20000;     /* how long the visitor waits before we show the call-me line */
    var ATTEMPT_TIMEOUT = 9000;
    var TEASER_DELAY = 1800, TEASER_LIFE = 30000;

    var root = document.querySelector('[data-ma-hb]');
    if (!root) return;

    /* 16 Sep 2026 (Claude, Hayden approved). A failed send used to be visible only to the
       visitor: they saw the call-me line, we saw nothing at all. That is how an enquiry on the
       ASA dam aerator reached nobody on 14 Sep, twice, before the shopper gave up and tapped
       Call for a quote. Every failure now raises a Clarity event and a GA4 event, and asks
       Clarity to keep that recording, so a broken path shows up the same day instead of at the
       next audit. Names, phones and messages are never sent: only the event name. */
    function track(name) {
      try {
        if (typeof window.clarity === 'function') { window.clarity('event', name); window.clarity('upgrade', name); }
      } catch (err) {}
      try {
        if (typeof window.gtag === 'function') { window.gtag('event', name, { send_to: 'G-RSBJ67K3FQ' }); }
      } catch (err) {}
    }
    var fab = root.querySelector('[data-ma-hb-toggle]');
    var panel = root.querySelector('#ma-hb-panel');
    var closeBtn = root.querySelector('[data-ma-hb-close]');
    var teaser = root.querySelector('[data-ma-hb-teaser]');
    var teaserClose = root.querySelector('[data-ma-hb-teaser-close]');
    var greetingEl = root.querySelector('[data-ma-hb-greeting]');
    var form = root.querySelector('[data-ma-hb-form]');
    var done = root.querySelector('[data-ma-hb-done]');
    var doneTitle = root.querySelector('[data-ma-hb-done-title]');
    var doneLine = root.querySelector('[data-ma-hb-done-line]');
    var welcome = root.querySelector('[data-ma-hb-welcome]');
    var statusEl = root.querySelector('[data-ma-hb-status]');
    var subEl = root.querySelector('[data-ma-hb-sub]');
    var pips = root.querySelectorAll('[data-ma-hb-pip]');
    var sendBtn = root.querySelector('[data-ma-hb-send]');
    var errorEl = root.querySelector('[data-ma-hb-error]');

    /* ---------- presence: Sydney clock, because that is when Hayden is awake ---------- */
    function sydneyHour() {
      try {
        var h = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', hour: 'numeric', hour12: false }).format(new Date());
        return parseInt(h, 10) % 24; /* some engines return 24 for midnight */
      } catch (err) {
        return new Date().getHours(); /* no Intl/tz data, fall back to the device */
      }
    }
    var isOpen = (function () { var h = sydneyHour(); return h >= OPEN_HOUR && h < CLOSE_HOUR; })();

    for (var i = 0; i < pips.length; i++) { if (!isOpen) pips[i].classList.add('is-away'); }
    if (!isOpen) {
      statusEl.textContent = 'Away';
      statusEl.classList.add('is-away');
      subEl.textContent = "I'll reply first thing in the morning";
      welcome.textContent = "Welcome to My Acre. Leave your number and I'll text you first thing.";
    }

    /* ---------- greeting: the visitor's own clock, so Perth reads right ---------- */
    /* No emoji, Hayden's call 21 Aug. Plain text, so textContent not innerHTML. */
    function greeting() {
      var h = new Date().getHours();
      var word = h < 12 ? 'Good morning' : (h < 17 ? 'Good afternoon' : 'Good evening');
      return word + ', Hayden here.';
    }
    greetingEl.textContent = greeting();

    /* ---------- open / close ---------- */
    /* Open the connection to the relay while the customer types, so Send answers quickly. */
    var warmed = false;
    function warmRelay() {
      if (warmed) return;
      warmed = true;
      var link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = RELAY_ORIGIN;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    }
    function open() {
      panel.hidden = false;
      root.classList.add('is-open');
      document.body.classList.add('ma-hb-open'); /* lets the Google bubble step aside on mobile */
      fab.setAttribute('aria-expanded', 'true');
      hideTeaser();
      warmRelay();
      document.addEventListener('keydown', esc);
      var nameField = root.querySelector('#ma-hb-name');
      /* Only pull focus into the form if the confirmation is not already showing. */
      if (nameField && done.hidden) setTimeout(function () { nameField.focus(); }, 50);
    }
    function close() {
      panel.hidden = true;
      root.classList.remove('is-open');
      document.body.classList.remove('ma-hb-open');
      fab.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', esc);
    }
    function esc(e) { if (e.key === 'Escape') close(); }
    fab.addEventListener('click', open);
    closeBtn.addEventListener('click', close);

    /* ---------- teaser: once per VISIT, 30 seconds on screen ---------- */
    var TEASER_KEY = 'ma_hb_teaser_seen';
    var hideTimer = null;
    function hideTeaser() {
      if (teaser.hidden) return;
      teaser.classList.add('is-going');
      var t = setTimeout(function () { teaser.hidden = true; teaser.classList.remove('is-going'); }, 300);
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      return t;
    }
    if (teaserClose) {
      teaserClose.addEventListener('click', function (e) { e.stopPropagation(); hideTeaser(); });
    }
    try {
      /* sessionStorage, not localStorage: it clears when the tab closes, so the greeting
         returns on the customer's next visit instead of never showing again. */
      if (!sessionStorage.getItem(TEASER_KEY)) {
        var showTeaser = function () {
          if (root.classList.contains('is-open')) return;
          teaser.hidden = false;
          hideTimer = setTimeout(hideTeaser, TEASER_LIFE);
        };
        /* 21 Oct 2026 (Claude, buy box v2, Hayden approved): on a product page the greeting
           holds back until the shopper reaches the last promise row under Add to Cart, then
           opens once. Every other page keeps the timed greeting below. */
        var lastPromise = document.querySelector('.product--outer .ma-buybox > .ma-agrid > :last-child');
        if (lastPromise && 'IntersectionObserver' in window) {
          var teaserIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              teaserIo.disconnect();
              try { sessionStorage.setItem(TEASER_KEY, '1'); } catch (err2) {}
              showTeaser();
            });
          }, { threshold: 0.6 });
          teaserIo.observe(lastPromise);
        } else {
          setTimeout(showTeaser, TEASER_DELAY);
          sessionStorage.setItem(TEASER_KEY, '1');
        }
      }
    } catch (err) { /* private mode, just skip the teaser rather than throwing */ }

    /* ---------- keep clear of the sticky ATC bar / mobile cart bar ---------- */
    var GAP = 14, raf = 0;
    function obstacleHeight() {
      var bar = document.querySelector('.ma-sticky-atc.is-visible') || document.querySelector('.ma-mobile-bar');
      if (!bar) return 0;
      /* Both bars are position:fixed, so offsetParent is always null on them —
         that is not a visibility signal here. Use computed display instead. */
      var cs = getComputedStyle(bar);
      if (cs.display === 'none' || cs.visibility === 'hidden') return 0;
      var rect = bar.getBoundingClientRect();
      if (!rect.height) return 0;
      return Math.round(rect.height);
    }
    function applyOffset() {
      raf = 0;
      var h = obstacleHeight();
      root.style.bottom = h ? (h + GAP) + 'px' : '';
    }
    function sync() { if (!raf) raf = requestAnimationFrame(applyOffset); }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('load', sync);
    /* 21 Oct 2026 (Claude, buy box v2): the sticky bar now appears while the shopper is still
       choosing, so re-measure the moment it shows or hides, not only on the next scroll. */
    var stickyBarEl = document.querySelector('.ma-sticky-atc');
    if (stickyBarEl && 'MutationObserver' in window) new MutationObserver(sync).observe(stickyBarEl, { attributes: true, attributeFilter: ['class', 'hidden'] });
    sync();

    /* ---------- delivery ---------- */

    /* A write-ahead log of one. The enquiry is stashed before the first attempt and cleared
       only on a confirmed store, so nothing depends on this page staying open. */
    function stash(payload) {
      try { localStorage.setItem(PENDING_KEY, JSON.stringify({ at: Date.now(), payload: payload })); } catch (err) {}
    }
    function unstash() {
      try { localStorage.removeItem(PENDING_KEY); } catch (err) {}
    }
    function readStash() {
      try {
        var raw = localStorage.getItem(PENDING_KEY);
        if (!raw) return null;
        var rec = JSON.parse(raw);
        if (!rec || !rec.payload || !rec.at || Date.now() - rec.at > PENDING_LIFE) { unstash(); return null; }
        return rec.payload;
      } catch (err) { return null; }
    }

    function uuid() {
      try {
        if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
        var b = new Uint8Array(16);
        crypto.getRandomValues(b);
        b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
        var h = [];
        for (var i = 0; i < 16; i++) h.push((b[i] + 256).toString(16).slice(1));
        return h.slice(0, 4).join('') + '-' + h.slice(4, 6).join('') + '-' + h.slice(6, 8).join('') + '-' + h.slice(8, 10).join('') + '-' + h.slice(10).join('');
      } catch (err) {
        return 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      }
    }

    /* One attempt. Resolves 'ok' (stored), 'reject' (the relay refused it and always will,
       so stop), or 'retry' (anything transient: offline, blocked, 5xx, timeout). */
    function attempt(payload) {
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ATTEMPT_TIMEOUT) : 0;
      return fetch(RELAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(payload),
        keepalive: true, /* lets the request outlive the page if they close the tab */
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (res) {
        clearTimeout(timer);
        if (res.ok) return 'ok';
        if (res.status === 400 || res.status === 403 || res.status === 413) return 'reject';
        return 'retry';
      }).catch(function () {
        clearTimeout(timer);
        return 'retry';
      });
    }

    /* Keep trying until the deadline, backing off so a flapping connection is not hammered. */
    function deliver(payload, deadline) {
      var wait = 700;
      function round() {
        return attempt(payload).then(function (out) {
          if (out === 'ok' || out === 'reject') return out;
          if (Date.now() + wait >= deadline) return 'retry';
          var pause = wait;
          wait = Math.min(wait * 2, 5000);
          return new Promise(function (done) { setTimeout(done, pause); }).then(round);
        });
      }
      return round();
    }

    /* Anything left in the stash from a previous visit goes out quietly now. */
    function replayPending() {
      var payload = readStash();
      if (!payload) return;
      deliver(payload, Date.now() + SEND_DEADLINE).then(function (out) {
        if (out === 'reject') track('chat_replay_rejected');
        if (out === 'ok') track('chat_replay_sent');
        if (out === 'ok' || out === 'reject') unstash();
      });
    }
    setTimeout(replayPending, 2500); /* after the page has settled, never blocking first paint */
    window.addEventListener('online', replayPending);

    /* ---------- submit ---------- */
    function markBad(el, bad) { if (el) el.classList.toggle('is-bad', !!bad); }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true;

      /* The honeypot used to return here, which meant a visitor whose password manager or
         browser autofill filled the off-screen "Company" field pressed Send and watched
         nothing happen at all. It is a signal, not a verdict: it rides along in the payload
         and the relay stores and flags it, so a false positive costs a second look rather
         than a sale. */

      var nameEl = root.querySelector('#ma-hb-name');
      var phoneEl = root.querySelector('#ma-hb-phone');
      var msgEl = root.querySelector('#ma-hb-message');
      var name = nameEl.value.trim();
      var phone = phoneEl.value.trim();
      var message = msgEl.value.trim();

      markBad(nameEl, !name); markBad(phoneEl, !phone); markBad(msgEl, !message);
      if (!name || !phone || !message) {
        var firstBad = root.querySelector('.is-bad');
        if (firstBad) firstBad.focus();
        track('chat_send_blocked');
        return;
      }

      sendBtn.disabled = true;
      sendBtn.textContent = 'Sending';

      /* Raw fields only: the relay builds the Slack message itself (layout, mentions,
         escaping). The honeypot rides along so the relay can drop replays that fill it. */
      var payload = {
        cid: uuid(), /* idempotency key: a replay of this same enquiry can never double-post */
        v: WIDGET_V,
        name: name,
        phone: phone,
        message: message,
        page: location.href,
        company: root.querySelector('#ma-hb-company').value
      };
      stash(payload); /* on disk before it is on the wire */

      function showConfirm() {
        /* Collapse the form, then swap in the confirmation. The timeout matches the
           collapse animation so the two never overlap mid-transition. */
        form.classList.add('is-going');
        setTimeout(function () {
          form.hidden = true;
          form.classList.remove('is-going');
          welcome.hidden = true;

          doneTitle.textContent = 'Got it, ' + name + '.';
          doneLine.innerHTML = isOpen
            ? "I'll text you back on <b>" + escapeHtml(phone) + "</b> shortly."
            : "I'll text you back on <b>" + escapeHtml(phone) + "</b> first thing in the morning.";
          done.hidden = false;
          done.setAttribute('tabindex', '-1');
          done.focus({ preventScroll: true });
        }, 260);
      }
      function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function showError() {
        sendBtn.disabled = false;
        sendBtn.textContent = 'Send';
        errorEl.hidden = false;
      }

      /* text/plain keeps this a CORS "simple" request, so there is no preflight round trip;
         the relay parses the body as JSON regardless. The relay answers 200 once the enquiry
         is stored, not once Slack accepts it, so the confirmation is now a promise we can
         actually keep: we have the details, and every notifier can be down without losing
         them. Retries run until the deadline; after that the visitor gets the call-me line
         while the stash keeps trying on their next page view. */
      deliver(payload, Date.now() + SEND_DEADLINE).then(function (out) {
        if (out === 'ok') { unstash(); showConfirm(); return; }
        if (out === 'reject') { unstash(); track('chat_send_rejected'); showError(); return; }
        track('chat_send_failed');
        showError(); /* stash deliberately kept, so replayPending() can finish the job later */
      });
    });
  })();